// @flow
import { HTTPStatusCodes } from 'constants/httpStatusCodes';
import API from 'services/API';
import { Endpoints } from 'UI/constants/endpoints';
import { getErrorMessage } from 'UI/utils';

const tinymceBaseConfig = {
  height: 400,
  selector: 'textarea',
  content_style: 'html, body { height: fit-content; min-height: 300px; }',
  menubar: false,
  contextmenu: false,
  image_description: false,
  toolbar_mode: 'wrap',
  browser_spellcheck: true
};

const tinymceBasicToolbar = `undo redo |
  bold italic underline |
  backcolor forecolor |
  alignleft aligncenter alignright alignjustify |
  bullist numlist |
  image link |
`;

const tinymceBasePlugins = [
  'advlist autolink lists charmap print preview anchor',
  'searchreplace visualblocks code fullscreen',
  'insertdatetime media table paste code help wordcount'
];

const buildUploaderWithConfig = ({ endpoint, fieldName }) => {
  const uploader = async (blob, success, failure) => {
    try {
      const formData = new FormData();
      formData.append(fieldName, blob.blob(), blob.filename());
      const response = await API.post(endpoint, formData);
      if (response.status === HTTPStatusCodes.Created) {
        const { url } = response.data;
        success(url);
      }
    } catch (e) {
      failure(getErrorMessage(e));
    }
  };
  return uploader;
};

export const tinymceConfig = {
  ...tinymceBaseConfig,
  plugins: tinymceBasePlugins,
  toolbar: tinymceBasicToolbar
};

export const tinymceBulkConfig = {
  ...tinymceBaseConfig,
  plugins: [...tinymceBasePlugins, 'link image'],
  toolbar: tinymceBasicToolbar.replace(/underline /, 'underline fontsizeselect'),
  images_upload_handler: buildUploaderWithConfig({
    endpoint: Endpoints.BulkEmailBodyImage,
    fieldName: 'upload'
  })
};

export const backNavigateListConfig = {
  backNavigation: true
};

export const TINY_WITH_IMAGES_CONFIG = {
  ...tinymceConfig,
  plugins: [...tinymceBasePlugins, 'image'],
  paste_data_images: true,
  images_upload_handler: buildUploaderWithConfig({ endpoint: Endpoints.Images, fieldName: 'file' })
};
